import React, { FC } from 'react';
import Modal from '@uikit/Modal/Modal';
import { ControlledTextEditor } from '@uikit/FormItems/ControlledItems';
import { ControlledTextEditorModalPropsType } from '@uikit/FormItems/constants';

const ControlledTextEditorModal: FC<ControlledTextEditorModalPropsType> = ({
  name,
  control,
  title,
  closeModal,
  dataTestId,
}) => {
  return (
    <Modal
      data-test-id={`${dataTestId}-controlled-text-editor-modal`}
      title={title}
      maxWidth="1018px"
      closeClick={closeModal}
      className="input-editor-modal"
    >
      <ControlledTextEditor name={name} control={control} height="663px" />
    </Modal>
  );
};

export default ControlledTextEditorModal;
